import { render, staticRenderFns } from "./buscadorV1.vue?vue&type=template&id=791bd750"
import script from "./buscadorV1.vue?vue&type=script&lang=js"
export * from "./buscadorV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports